export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <path
                d="M23.3333 28.0002C28.488 28.0002 32.6667 23.8215 32.6667 18.6668C32.6667 13.5122 28.488 9.3335 23.3333 9.3335C18.1787 9.3335 14 13.5122 14 18.6668C14 23.8215 18.1787 28.0002 23.3333 28.0002Z"
                stroke="black"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M43.1667 18.6665L43.1667 30.3332" stroke="#F7A40A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M49 24.5L37.3333 24.5" stroke="#F7A40A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M39.6667 46.6667V47.9167C40.357 47.9167 40.9167 47.357 40.9167 46.6667H39.6667ZM7 46.6667H5.75C5.75 47.357 6.30964 47.9167 7 47.9167V46.6667ZM40.9167 46.6667C40.9167 35.829 33.1959 26.75 23.3333 26.75V29.25C31.5121 29.25 38.4167 36.8857 38.4167 46.6667H40.9167ZM23.3333 26.75C13.4708 26.75 5.75 35.829 5.75 46.6667H8.25C8.25 36.8857 15.1546 29.25 23.3333 29.25V26.75ZM39.6667 45.4167H7V47.9167H39.6667V45.4167Z"
                fill="#010101"
            />
        </svg>
    );
}
